/**
 * Pure helpers for "copy message" (Art. 50 Abs. 2 AI Act — machine-readable
 * marking of AI-generated content, in force from 2026-12-02).
 *
 * The chat already marks an AI turn while it stays inside Etch (the
 * `.etch-message__ai` badge, ./authorship.js — Art. 50 Abs. 1). Copying moves
 * the text somewhere that badge cannot follow it — a document, an email, a
 * ticket — so the same duty is discharged here: text copied from an
 * AI-authored turn carries a plain-text marking appended to it. Kept as a
 * pure function, like authorship.js, so it is covered without a DOM (vitest
 * runs in the `node` environment for this repo — see Message.jsx).
 */

/**
 * @param {string} text - the assembled copy payload (header + body + sources).
 * @param {boolean} isAi - whether the turn being copied was AI-authored.
 * @param {string} notice - translated marking text, e.g. "— AI-generated with Etch".
 * @returns {string} `text`, with the marking appended on its own paragraph
 *   when `isAi` and a notice was given; `text` unchanged otherwise.
 */
export function appendAiCopyNotice(text, isAi, notice) {
  if (!isAi || !notice) return text;
  return `${text}\n\n${notice}`;
}
